export default "/static/media/logo.7080836d.svg";